var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TrustpilotWrapper',{attrs:{"widget-id":_vm.trustpilotMicroButtonId,"show-widget":_vm.showWidget,"trustpilot-height":_vm.TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT}})}
var staticRenderFns = []

export { render, staticRenderFns }